export default () => {
  const saveLessonSeenState = (lessonId, percentage = 0) => {
    if (typeof window === "undefined") {
      return 0;
    };
  
    if (!lessonId || !percentage) return;
    let currentPercentage = window.localStorage.getItem(lessonId);

    currentPercentage = Math.max(Math.min(100, percentage), currentPercentage);
    window.localStorage.setItem(lessonId, currentPercentage);
    return currentPercentage;
  };
  const getLessonSeenState = (lessonId) => {
    if (typeof window === "undefined") {
      return 0;
    };
    return window.localStorage.getItem(lessonId) || 0;
  };
  return { saveLessonSeenState, getLessonSeenState };
};
